
  document.addEventListener('DOMContentLoaded', function () {
    const tabsContainers = document.querySelectorAll('.tabs');

    tabsContainers.forEach((tabsContainer) => {
      const tabHeadings = tabsContainer.querySelectorAll('.tabs__heading a');

      tabHeadings.forEach((tabHeading) => {
        tabHeading.addEventListener('click', function (event) {
          event.preventDefault();

          tabsContainer.querySelectorAll('.tabs__heading a').forEach((link) => {
            link.classList.remove('active');
          });

          tabsContainer.querySelectorAll('.tabs-container').forEach((grid) => {
            grid.classList.remove('active');
          });


          this.classList.add('active');

          const targetId = this.getAttribute('href').replace('#', ''); 
          const targetGrid = tabsContainer.querySelector(`#${targetId}`);

          if (targetGrid) {
            targetGrid.classList.add('active');
          }
        });
      });
    });
  });
